import * as THREE from 'three';

export const FULL = new THREE.Vector3(16 / 9, 1, 0);
export const SQUARE = new THREE.Vector3(1, 1, 0);
export const SMALL = new THREE.Vector3(0.77, 1, 0);
